export default "__VITE_ASSET__DtiwAJ5j__"